import { callAuthorizedGraphQLEndpoint } from '../../../../../../Module/graphQL'

export async function getBrandAmbassadorActivity(variables) {
  const query = `query ($ambassadorId:ID! $first:Int $after:String) {
    brandAmbassador(ambassadorId:$ambassadorId) {
      missions (first:$first after:$after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
        node {
           id
           status
           cancelled
           timeRangeStart
           timeOfDay
           totalFlyersDistributed
           bonusDisqualified
           campaign {
             metrics {
              nodes {
                id
                name
                label
                isPrimary
              }
             }
           }
           cityPlan{
            city{
              name
              id
            }
           }
           location{
             name
             id
            }
           client{
             name
           }
           conversions{
             nodes {
               id
               timestamp
               inRedemption
               bonusDisqualified
               paid
               metric {
                id
                name
                label
                isPrimary
               }
              }
            }
           spyInformation{
            spyDetails{
              checkInTime
              }
            }
           ratingInfo{
             rating
             conversionRateSubRating
             conversionRateMean
             scanRateSubRating
             scanRateMean
             checkoutFlyerRateSubRating
             checkoutFlyerRateMean
             comparisonScope
           }
            type
          }
        }
      }  
    }
  }`
  const req = await callAuthorizedGraphQLEndpoint(query, variables)
  return req.json()
}
